import { createFileRoute } from "@tanstack/react-router";
import { TenantGlossaryPage } from "@client/components/settings/semantic-governance/tenant-glossary-page";

export const Route = createFileRoute("/_app/tenant-settings/semantic-governance/")({
  component: TenantGlossaryPage,
});
